import React from 'react';

const ChiropracticInfo = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-swastik-blue mb-8">Who is a chiropractor?</h2>
          <p className="text-gray-600 mb-6">
            A chiropractor treats many conditions affecting the nervous system and musculoskeletal system. Think of a chiropractor as a doctor who cares for any kind of muscle, bone or joint pain or dysfunction. The most common reasons for a chiropractic adjustment include:
          </p>
          <ul className="list-disc list-inside ml-4 mb-8">
            <li>Lower back pain</li>
            <li>Neck pain</li>
            <li>Muscle pain</li>
            <li>Headaches</li>
          </ul>
          <p className="text-gray-600 mb-6">
            In addition, chiropractors can treat musculoskeletal pain anywhere in your body: in your head and jaws, shoulders, elbows and wrists, hips and pelvis and your knees and ankles.
          </p>

          <h2 className="text-3xl font-bold text-swastik-blue mb-8 mt-12">What does a chiropractor do?</h2>
          <p className="text-gray-600 mb-6">
            Chiropractors treat aches, pains, creaks and strains. If you've got a problem that involves your musculoskeletal system, a chiropractor can offer alternative methods of treatment that don't involve prescribing medicine.
          </p>

          <h3 className="text-2xl font-semibold text-swastik-blue mb-4">Treatment that a chiropractor may offer includes:</h3>
          <ul className="list-disc list-inside ml-4 mb-8">
            <li className="mb-2">
              <strong>Adjustments:</strong> To gently realign joints to decrease pain and increase range of motion.
            </li>
            <li className="mb-2">
              <strong>Soft-tissue therapy:</strong> To relax tight muscles, relieve spasms and release tension in the connective tissue that surrounds each muscle (fascia).
            </li>
            <li className="mb-2">
              <strong>Exercises and stretches:</strong> To restore and maintain joint stability and mobility.
            </li>
            <li className="mb-2">
              <strong>Joint bracing/taping (Kinesio taping):</strong> To support sprained joints or muscles as they heal.
            </li>
            <li className="mb-2">
              <strong>Referrals to integrative medicine experts:</strong> For guidance on diet and nutrition to reduce inflammation and/or promote healthy eating to manage weight.
            </li>
          </ul>

          <h2 className="text-3xl font-bold text-swastik-blue mb-8 mt-12">Risks / Benefits</h2>
          <h3 className="text-2xl font-semibold text-swastik-blue mb-4">What are the benefits of a chiropractic adjustment?</h3>
          <p className="text-gray-600 mb-4">There are several benefits of a chiropractic adjustment including:</p>
          <ul className="list-disc list-inside ml-4">
            <li>Helps minimize migraines and neck-related headaches</li>
            <li>Improves your posture</li>
            <li>Reduces pain and improves range of motion of your spine and other joints</li>
            <li>Reduces symptoms of chronic conditions like osteoarthritis</li>
            <li>Treats minor neck or spine injuries, especially whiplash</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ChiropracticInfo; 